/**
 * @generated SignedSource<<647364a0d0bee84d523bce98f045d271>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceTodosSubscription$variables = {
  workspaceId: string;
};
export type WorkspaceTodosSubscription$data = {
  readonly todoWorkspaceChanged: {
    readonly body: string | null;
    readonly createdAtDate: {
      readonly isoString: string;
    };
    readonly expireAtDate: {
      readonly isoString: string;
    } | null;
    readonly id: string;
    readonly priorityOrder: number;
    readonly publishedAtDate: {
      readonly isoString: string;
    } | null;
    readonly status: WorkspaceTodoStatus;
    readonly title: string;
    readonly todoCount: number;
    readonly todosCompletedCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItem_todo">;
  } | null;
};
export type WorkspaceTodosSubscription = {
  response: WorkspaceTodosSubscription$data;
  variables: WorkspaceTodosSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UnzonedDate",
  "kind": "LinkedField",
  "name": "createdAtDate",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "todoCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "todosCompletedCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priorityOrder",
  "storageKey": null
},
v12 = [
  (v5/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isDate"
  }
],
v13 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodosSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspaceChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "publishedAtDate",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoListItem_todo"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodosSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspaceChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "publishedAtDate",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "scheduledPublishAt",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "Date",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "kind": "ScalarField",
            "name": "workspaceOwnerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOrg",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9d3aa833a17371b01dbe622a834c595",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodosSubscription",
    "operationKind": "subscription",
    "text": "subscription WorkspaceTodosSubscription(\n  $workspaceId: ID!\n) {\n  todoWorkspaceChanged(workspaceId: $workspaceId) {\n    id\n    title\n    body\n    createdAtDate {\n      isoString\n    }\n    publishedAtDate {\n      isoString\n    }\n    expireAtDate {\n      isoString\n    }\n    status\n    todoCount(workspaceId: $workspaceId)\n    todosCompletedCount(workspaceId: $workspaceId)\n    priorityOrder\n    ...WorkspaceTodoListItem_todo\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemDescriptionContentFiles_files on File {\n  id\n  ...FileIconBox_file\n}\n\nfragment ListItemDescriptionContentProducts_products on WorkspaceProduct {\n  id\n  ...WorkspaceTodoListItemProducts_WorkspaceProduct\n}\n\nfragment ListItemDescriptionContent_images on Image {\n  id\n  ...Image_image\n}\n\nfragment WorkspaceTodoListItemDescription_todo on TodoWorkspace {\n  title\n  descriptionImages {\n    ...ListItemDescriptionContent_images\n    id\n  }\n  descriptionFiles {\n    ...ListItemDescriptionContentFiles_files\n    id\n  }\n  linkedProducts {\n    ...ListItemDescriptionContentProducts_products\n    id\n  }\n}\n\nfragment WorkspaceTodoListItemProducts_WorkspaceProduct on WorkspaceProduct {\n  name\n}\n\nfragment WorkspaceTodoListItemStatus_todo on TodoWorkspace {\n  status\n  todoCount(workspaceId: $workspaceId)\n  todosCompletedCount(workspaceId: $workspaceId)\n}\n\nfragment WorkspaceTodoListItem_todo on TodoWorkspace {\n  id\n  expireAtDate {\n    ...FormattedDate\n  }\n  scheduledPublishAt {\n    ...FormattedDate\n  }\n  publishedAtDate {\n    ...FormattedDate\n  }\n  status\n  topic {\n    id\n    name\n  }\n  workspaceOwnerName(workspaceId: $workspaceId)\n  priority\n  ...WorkspaceTodoListItemStatus_todo\n  ...WorkspaceTodoListItemDescription_todo\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "0597edae30b60c188bdc559d24088ab8";

export default node;
